export default {"src":"/_next/static/media/remove-cart-bg.389cd8d5.svg","height":159,"width":360,"blurWidth":0,"blurHeight":0};